goog.provide("shadow.js.shim.module$src$svg$wpp$arrows$chevron_down_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$arrows$chevron_down_svg");
shadow.js.shim.module$src$svg$wpp$arrows$chevron_down_svg = shadow.js.nativeProvides["src/svg/wpp/arrows/chevron-down.svg"] = shadow$bridge("src/svg/wpp/arrows/chevron-down.svg");
module$shadow_js_shim_module$src$svg$wpp$arrows$chevron_down_svg.default = shadow.js.shim.module$src$svg$wpp$arrows$chevron_down_svg;
